<template>
  <div>
    <v-layout class="mt-3">
      <div class="subtitle-1 font-weight-medium">Image Details</div>
    </v-layout>
    <v-layout align-center>
      <v-flex>
        <v-btn
          color="primary"
          class="text-none subtitle-2 mt-3"
          @click="openImageGallery"
        >
          <v-icon small class="mr-2">mdi-image-multiple</v-icon>
          Image Gallery</v-btn
        >
      </v-flex>
    </v-layout>

    <v-layout v-if="imageUrl" class="mt-3">
      <v-flex>
        <v-card>
          <v-img
            gradient="to top left, rgba(0,0,0,0), rgba(0,0,0,.7)"
            aspect-ratio="1"
            :lazy-src="imageUrl"
            :src="imageUrl"
          >
            <v-layout>
              <v-btn dark icon @click="galleryImageDeselect">
                <v-icon> mdi-close </v-icon>
              </v-btn>
            </v-layout>
          </v-img>
        </v-card>
      </v-flex>
    </v-layout>
    <image-gallery @selectImage="galleryImageSelect" ref="imageGalleryRef" />
  </div>
</template>

<script>
import ImageGallery from './ImageGallery';
export default {
  components: {
    ImageGallery,
  },
  data() {
    return {
      imageUrl: '',
    };
  },
  methods: {
    openImageGallery() {
      this.$refs.imageGalleryRef.toggleDialog();
    },
    galleryImageSelect(image) {
      this.imageUrl = image.url;
      this.$emit('imageSelected', image);
    },
    galleryImageDeselect() {
      this.imageUrl = '';
      this.$emit('imageSelected', '');
    },
  },
};
</script>

<style></style>
